import axios from 'axios'
import generateQueryParamSource from '@/functions/generateQueryParamSource'

const axiosServer = axios.create({
  baseURL: `${process.env.VUE_APP_URL_SERVER}/v2`
})

axiosServer.interceptors.request.use(
  function (req) {
    const traceSource = generateQueryParamSource()

    req.url = req.url.includes('?')
      ? req.url + '&platform=kariermu' + traceSource
      : req.url + '?platform=kariermu' + traceSource
    return req
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default axiosServer
